import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { validateSortKey } from '../internal/helpers';
import { Head } from '../styled/TableHead';
import RankableHeadCell from './rankable/TableHeadCell';
import HeadCell from './TableHeadCell';

var TableHead = /*#__PURE__*/function (_React$Component) {
  _inherits(TableHead, _React$Component);

  var _super = _createSuper(TableHead);

  function TableHead() {
    var _this;

    _classCallCheck(this, TableHead);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "canSortOnEnterPressed", function (e, isSortable) {
      return isSortable && e.key === 'Enter';
    });

    return _this;
  }

  _createClass(TableHead, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      validateSortKey(this.props.sortKey, this.props.head);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) {
        validateSortKey(nextProps.sortKey, nextProps.head);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          head = _this$props.head,
          sortKey = _this$props.sortKey,
          sortOrder = _this$props.sortOrder,
          isFixedSize = _this$props.isFixedSize,
          onSort = _this$props.onSort,
          isRanking = _this$props.isRanking,
          isRankable = _this$props.isRankable,
          testId = _this$props.testId;

      if (!head) {
        return null;
      }

      var HeadCellComponent = isRankable ? RankableHeadCell : HeadCell;

      var cells = head.cells,
          rest = _objectWithoutProperties(head, ["cells"]);

      return /*#__PURE__*/React.createElement(Head, _extends({}, rest, {
        isRanking: isRanking,
        "data-testid": testId && "".concat(testId, "--head")
      }), /*#__PURE__*/React.createElement("tr", null, cells.map(function (cell, index) {
        var isSortable = cell.isSortable,
            key = cell.key,
            restCellProps = _objectWithoutProperties(cell, ["isSortable", "key"]);

        return /*#__PURE__*/React.createElement(HeadCellComponent, _extends({
          isFixedSize: isFixedSize,
          isSortable: !!isSortable,
          isRanking: isRanking,
          key: key || index,
          onClick: isSortable ? onSort(cell) : undefined,
          onKeyDown: function onKeyDown(e) {
            return _this2.canSortOnEnterPressed(e, isSortable) ? onSort(cell)() : undefined;
          },
          testId: testId,
          sortOrder: key === sortKey ? sortOrder : undefined
        }, restCellProps));
      })));
    }
  }]);

  return TableHead;
}(React.Component);

export default TableHead;